import { MoveRight } from 'lucide-react'

import { Button, Separator } from '@fortem-monorepo/react-ui'
import { PnlAttributions } from '@fortem-monorepo/web-sdk'

import { AttributionTypeBadge } from '@/pages/pnl-attributions/components/AttributionTypeBadge'
import { usePnlContext } from '@/pages/pnl-attributions/context'
import { formatNumber } from '@/utilities/format'

export interface SummaryRowProps {
  row: PnlAttributions.AttributionSummaryRow
}

export const SummaryRow: React.FC<SummaryRowProps> = ({ row }) => {
  const { setInspectingTrades } = usePnlContext()

  return (
    <div className={'@container border bg-gray-50 p-4 rounded-md overflow-hidden shadow-xs flex flex-col gap-4'}>
      <div className="flex items-center gap-8">
        <div className="flex flex-col gap-1">
          <AttributionTypeBadge attribution_type={row.attribution_type} />
          <span className="font-normal text-sm text-heading">{row.unique_identifier}</span>
        </div>
        <div className="hidden @[940px]:flex items-center gap-8">
          <div className={'flex items-center gap-8'}>
            <div className="flex flex-col gap-px text-right">
              <span className={'text-muted-foreground text-xs'}>Quantity</span>
              <span className="font-normal font-mono text-sm text-heading">{formatNumber(row.quantity)}</span>
            </div>
            <div className="flex flex-col gap-px text-right">
              <span className={'text-muted-foreground text-xs'}>Px (T)</span>
              <span className="font-normal font-mono text-sm text-heading">{row.px_t}</span>
            </div>
            <div className="flex flex-col gap-px text-right">
              <span className={'text-muted-foreground text-xs'}>Px (T-1)</span>
              <span className="font-normal font-mono text-sm text-heading">{row.px_tmo}</span>
            </div>
          </div>
          <div className={'flex items-center gap-8'}>
            <div className="flex flex-col gap-px text-right">
              <span className={'text-muted-foreground text-xs'}>Fx (T)</span>
              <span className="font-normal font-mono text-sm text-heading">{row.fx_rate_t}</span>
            </div>
            <div className="flex flex-col gap-px text-right">
              <span className={'text-muted-foreground text-xs'}>Fx (T-1)</span>
              <span className="font-normal font-mono text-sm text-heading">{row.fx_rate_tmo}</span>
            </div>
            <div className={'flex items-center gap-8'}>
              <div className="flex flex-col gap-px text-right">
                <span className={'text-muted-foreground text-xs'}>Net P&L</span>
                <span className="font-normal font-mono text-sm text-heading">{formatNumber(row.net_pnl)}</span>
              </div>
              <div className="flex flex-col gap-px text-right">
                <span className={'text-muted-foreground text-xs'}>Trades</span>
                <span className="font-normal font-mono text-sm text-heading">{row.attribution_ids.length}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-px ml-auto">
          <Button size="sm" variant="outline" onClick={() => setInspectingTrades(row)}>
            View Trades <MoveRight />
          </Button>
        </div>
      </div>
      <Separator className={'@[940px]:hidden @[925px]:my-4'} />
      <div className="flex @[940px]:hidden flex-wrap gap-8">
        <div className={'flex items-center gap-8'}>
          <div className="flex flex-col gap-px text-right">
            <span className={'text-muted-foreground text-xs'}>Quantity</span>
            <span className="font-normal font-mono text-sm text-heading">{formatNumber(row.quantity)}</span>
          </div>
          <div className="flex flex-col gap-px text-right">
            <span className={'text-muted-foreground text-xs'}>Px (T)</span>
            <span className="font-normal font-mono text-sm text-heading">{row.px_t}</span>
          </div>
          <div className="flex flex-col gap-px text-right">
            <span className={'text-muted-foreground text-xs'}>Px (T-1)</span>
            <span className="font-normal font-mono text-sm text-heading">{row.px_tmo}</span>
          </div>
        </div>
        <div className={'flex items-center gap-8'}>
          <div className="flex flex-col gap-px text-right">
            <span className={'text-muted-foreground text-xs'}>Fx (T)</span>
            <span className="font-normal font-mono text-sm text-heading">{row.fx_rate_t}</span>
          </div>
          <div className="flex flex-col gap-px text-right">
            <span className={'text-muted-foreground text-xs'}>Fx (T-1)</span>
            <span className="font-normal font-mono text-sm text-heading">{row.fx_rate_tmo}</span>
          </div>
        </div>
        <div className={'flex items-center gap-8'}>
          <div className="flex flex-col gap-px text-right">
            <span className={'text-muted-foreground text-xs'}>Net PnL</span>
            <span className="font-normal font-mono text-sm text-heading">{formatNumber(row.net_pnl)}</span>
          </div>
          <div className="flex flex-col gap-px text-right">
            <span className={'text-muted-foreground text-xs'}>Trades</span>
            <span className="font-normal font-mono text-sm text-heading">{row.attribution_ids.length}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
